export const UPDATE_FORM_STATUS = 'UPDATE_FORM_STATUS';
export const UPDATE_RECORD = 'UPDATE_RECORD';